import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Tab, Tabs, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import TabPanel from '../../TabPanel';
import { Users } from './Users';
import Permissions from './Permissions';
import Groups from './Groups';
import Roles from './Roles';
import PageHeader from '../../controls/PageHeader';

const PREFIX = 'PermissionsAdmin';

const classes = {
  container: `${PREFIX}-container`,
  molinaContainer: `${PREFIX}-molinaContainer`,
  header: `${PREFIX}-header`,
  title: `${PREFIX}-title`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${classes.container}`]: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  [`&.${classes.molinaContainer}`]: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    margin: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  [`& .${classes.header}`]: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(3),
  },
  [`& .${classes.title}`]: {
    fontFamily: 'Bitter',
    fontWeight: 700,
    fontSize: 30,
  },
}));

export default function PermissionsAdmin() {
  const { t } = useTranslation('common');

  const [tabIndex, setTabIndex] = React.useState(0);

  const handleTabChange = (_evt: React.ChangeEvent<{}>, newValue: number) => {
    setTabIndex(newValue);
  };

  return (
    <StyledBox className={classes.container}>
      <PageHeader title={`${t('settings.permissions')}`} />
      <Box>
        <Tabs
          indicatorColor="primary"
          textColor="primary"
          value={tabIndex}
          onChange={handleTabChange}
          variant="standard">
          <Tab label={t('settings.users')} data-testid="tab-one" />
          <Tab label={t('settings.permissions')} data-testid="tab-two" />
          <Tab label={t('settings.groups')} data-testid="tab-three" />
          <Tab label={t('settings.roles')} data-testid="tab-four" />
        </Tabs>
        <TabPanel value={tabIndex} index={0}>
          <Users />
        </TabPanel>
        <TabPanel value={tabIndex} index={1}>
          <Permissions />
        </TabPanel>
        <TabPanel value={tabIndex} index={2}>
          <Groups />
        </TabPanel>
        <TabPanel value={tabIndex} index={3}>
          <Roles />
        </TabPanel>
      </Box>
    </StyledBox>
  );
}
